import { useAuth0 } from '@auth0/auth0-react';
import { Menu } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import LoginButton from '../../../auth/LoginButton';
import LogoutButton from '../../../auth/LogoutButton';
import UserAvatar from '../../../auth/UserAvatar';
import { NavbarIconButtonWithLabel } from '../NavbarIconButtonWithLabel';
/**
 * Avatar button that opens a logout link
 */
const UserNavButton = () => {
  const { user, isAuthenticated } = useAuth0();
  const { t } = useTranslation();

  // Handle open close of popout menu
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // extract first name or display blank if not found
  let firstName = '';
  if (user && user?.name) {
    if (user.name?.includes(' ')) {
      firstName = user?.name.split(' ')[0];
    } else if (user.name?.includes('.')) {
      firstName = user?.name.split('.')[0];
    } else if (user.name?.includes('@')) {
      firstName = user?.name.split('@')[0];
    } else {
      firstName = user?.name;
    }
  }

  return (
    <>
      <NavbarIconButtonWithLabel
        customIcon
        label={
          firstName ? `${t('Hi, {{name}}!', { name: firstName })}` : 'Log Out'
        }
        onClick={handleOpenMenu}
      >
        <UserAvatar pxSize={24} />
      </NavbarIconButtonWithLabel>
      <Menu
        anchorEl={anchorEl}
        id='account-menu'
        open={open}
        onClose={handleCloseMenu}
        onClick={handleCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        hideBackdrop
        elevation={0}
        sx={{ '& .MuiPaper-root': { backgroundColor: 'transparent' } }}
      >
        {isAuthenticated ? <LogoutButton /> : <LoginButton />}
      </Menu>
    </>
  );
};

export default UserNavButton;
